import React, { Component, useState, useRef, useEffect } from 'react';


import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';
import { openUrl } from '../99_untils/flutterCallback';


import './Footer.css';

import {
  // Navigate,
  // useNavigate,
  Link,
} from 'react-router-dom';

import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

export default function FooterDesktop(props) {
  // console.log("Footer constructor started ")
  const isMountedRef = useRef();

  const { t } = useTranslation();

  // var targetWidth = window.innerWidth;
  // var targetHeight = window.innerHeight;


  useEffect(() => {

    isMountedRef.current = true;

    // const handleResize = () => {
    //   targetWidth = window.innerWidth;
    //   targetHeight = window.innerHeight;
    // };

    // handleResize();

    // window.addEventListener("resize", handleResize);

    return () => {
      isMountedRef.current = false;
      // window.removeEventListener("resize", handleResize);
      // console.log("Footer unmount")

    };
  }, []);





  return (
    <div className="footer-desktop-wrap" >
            <Container className="" fluid>
              <Row className=''>
                <Col className='text-left' >
                  <div className='footer-text color-text-pink-dark'>{t('FooterInfoDashCopy')}</div>
                </Col>
                <Col className='text-right'>

                  <Link to="/" className="footer-text color-text-pink-dark" onClick={(e) => {
                    e.preventDefault();
                    openUrl("https://www.d-ash.com/", "https://www.d-ash.com/");
                  }}>{t('FooterInfoAboutUs')}</Link>
                </Col>
              </Row>
            </Container>
    </div>
  );
  // }
}

